import { render, staticRenderFns } from "./TheLayoutMobile.vue?vue&type=template&id=223bbb92&scoped=true"
import script from "./TheLayoutMobile.vue?vue&type=script&lang=js"
export * from "./TheLayoutMobile.vue?vue&type=script&lang=js"
import style0 from "./TheLayoutMobile.vue?vue&type=style&index=0&id=223bbb92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223bbb92",
  null
  
)

export default component.exports